import { render, staticRenderFns } from "./ArrowCodeIcon.vue?vue&type=template&id=5bc2218d&"
import script from "./ArrowCodeIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowCodeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports